export {default} from './priceBlock';
